<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>更换手机号码</h1>
        <span class="pull-right icon-right" @click="updatePhone()">确定</span>
      </div>
      <div class="liner"></div>
    </div>



    <div class="main-page class-edit">
      <p class="margin-15">您当前使用的手机号码是：{{now_phone_num}}</p>
      <div class="telephone-change">
        <ul class="list-group-item tinny">
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix group-txt">
              <span class="pull-left">+86</span>
              <span class="block"><input class="margin-x-15 font-14" type="number" placeholder="请填写新手机号码" v-model="phone_num"></span>
            </div>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix group-txt">
              <span class="block"><input class="font-14" type="number" placeholder="输入验证码" v-model="check_code"></span>
              <a class="yzm" @click.prevent="getCheckCode" v-if="code_sec_msg = '获取验证码'">{{code_sec_msg}}</a>
              <a class="yzm gray" v-else>{{code_sec_msg}}</a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { service } from '../../../service'
import { Toast } from 'mint-ui'
export default {
  data () {
    return {
      img_default: require('../../../assets/images/img-default.png'),
      old_phone_num: '',
      login_data: JSON.parse(window.localStorage['login_data']),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      get_check_code_para: service.setPara('getCheckCode'),
      update_phone_para: service.setPara('updatePhone'),
      get_code_sec: 120,
      code_sec_msg: '获取验证码',
      int_code_interval: 0,
      phone_num: '',
      check_code: ''
    }
  },
  mounted: function () {
    this.old_phone_num = this.cookie_login_data.phoneNum
  },
  methods: {
    // 获取验证码
    getCheckCode: function () {
      var reg = /^1\d{10}$/
      this.phone_num = $.trim(this.phone_num)
      if (this.get_code_sec !== 120) {
        return
      }
      if (this.phone_num == this.old_phone_num) {
        Toast('要修改的手机号码不能和旧手机号码一致！')
        return
      }
      if (this.phone_num === '') {
        Toast('请输入手机号')
        return
      }
      if (!reg.exec(this.phone_num)) {
        Toast('请输入正确的手机号')
        return
      }
      this.get_check_code_para.phone_num = this.phone_num

      let that = this
      let obj = {context: this, para: this.get_check_code_para, successFun: (response) => {
        Toast('验证码已发送')
        that.int_code_interval = setInterval(that.setIntervalCode, 1000)
      }}
      service.request(obj)
    },
    // 倒计时
    setIntervalCode: function () {
      this.get_code_sec -= 1
      if (this.get_code_sec < 0) {
        this.get_code_sec = 120
        window.clearInterval(this.int_code_interval)
        this.code_sec_msg = '获取验证码'
      } else {
        this.code_sec_msg = '获取验证码（' + this.get_code_sec + '）'
      }
    },
    // 修改手机
    updatePhone: function () {
      var reg = /^1\d{10}$/
      var regCode = /^\d{6}$/
      this.phone_num = $.trim(this.phone_num)
      this.check_code = $.trim(this.check_code)
      if (this.phone_num === '') {
        Toast('请输入手机号')
        return
      }
      if (!reg.exec(this.phone_num)) {
        Toast('请输入正确的手机号')
        return
      }
      if (this.check_code === '') {
        Toast('请输入验证码')
        return
      }
      if (!regCode.exec(this.check_code)) {
        Toast('请输入6位数字的验证码')
        return
      }

      this.update_phone_para.oldPhoneNum = this.old_phone_num
      this.update_phone_para.checkCode = this.check_code
      this.update_phone_para.newPhoneNum = this.phone_num

      let that = this
      let obj = {context: this, para: this.update_phone_para, successFun: (response) => {
        Toast('修改成功')
        that.cookie_login_data.phoneNum = that.phone_num
        // $.cookie('login_data', JSON.stringify(that.cookie_login_data), { expires: 7, path: '/' })
        window.localStorage['basic_login_data'] = JSON.stringify(that.cookie_login_data)
        window.history.go(-1)
      }}
      service.request(obj)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// UpdatePhone.vue?403ff384